const config = require('../../config/runtime_config.js')

module.exports = [
	{
		path: 'manual_tasks',
		name: 'Maestro manual tasks',
		query: {},
		component: () => import('@/pages/maestro/tasks/manual_tasks.vue'),
		meta: {
			label: 'Tâches manuelles Maestro',
			icon: 'assignment',
			description: `Dashboard des tâches manuelles Maestro`,
			has_home_link: true
		}
	},
	{
		path: '/prestations',
		name: 'Prestations',
		component: () => import('@/pages/maestro/job/prestations.vue'),
		meta: {
			label: 'Prestations',
			icon: 'play_arrow',
			description: `Dashboard des prestations clients`,
			has_home_link: true
		}
	},
	{
		path: '/prestation/:id',
		name: 'Prestation',
		component: () => import('@/pages/maestro/job/prestation.vue'),
		meta: {
			label: 'Prestation',
			icon: 'play_arrow',
			description: `Lancer et visualiser une prestation`,
			disabled: true
		}
	},
	{
		path: '/sequencer/:id',
		name: 'Sequencer',
		params: { id: 'new' },
		component: () => import('@/pages/maestro/sequencer/sequencer.vue'),
		meta: {
			label: 'Sequencer',
			icon: 'code',
			description: ``,
			disabled: `${config._$ppt9qr}` === 'production'
		}
	},
	{
		path: 'jobs',
		name: 'Maestro jobs',
		query: {},
		component: () => import('@/pages/maestro/jobs/jobs.vue'),
		meta: {
			label: 'Jobs Maestro',
			icon: 'queue_music',
			description: `Dashboard des jobs Maestro`,
			has_home_link: true
		}
	},
	{
		path: 'jobs_query',
		name: 'Maestro jobs query',
		component: () => import('@/pages/maestro/jobs/jobs_query.vue'),
		meta: {
			label: 'Jobs Maestro Query',
			icon: 'queue_music',
			description: `Lanceur de dashboard des jobs Maestro`,
			disabled: true
		}
	},
	{
		path: 'jobs2',
		name: 'jobs2',
		redirect: {
			name: 'Maestro jobs'
		},
		meta: {}
	},
	{
		path: '/compositore/:id',
		name: 'Compositore',
		params: { id: 'new' },
		component: () => import('@/pages/maestro/compositore/compositore.vue'),
		meta: {
			label: 'Compositore',
			icon: 'device_hub',
			description: `Editeur de workflows Maestro`
		}
	},
	{
		path: 'job/:jr_id',
		name: 'Maestro job',
		props: true,
		component: () => import('@/pages/maestro/job/job_request.vue'),
		meta: {
			label: 'Job Maestro',
			icon: 'queue_music',
			description: `Page de visualisation de job Maestro`,
			disabled: true
		}
	},
	{
		path: 'task/:id',
		name: 'Maestro tasks',
		component: () => import('@/pages/maestro/task/maestroTask_generic.vue'),
		meta: {
			label: 'Tâche Maestro',
			icon: 'queue_music',
			description: `Page de visualisation de tache Maestro`,
			disabled: true
		}
	},
	{
		path: 'form/:id',
		name: 'Maestro Forms',
		component: () => import('@/pages/maestro/forms/maestroForm_generic.vue'),
		meta: {
			label: 'Form Maestro',
			icon: 'queue_music',
			description: `Page de formulaire de tache humaine Maestro`,
			disabled: true
		}
	},
	{
		path: 'quality_check/:id',
		name: 'quality check',
		component: () => import('@/pages/maestro/forms/qc/quality_check.vue'),
		meta: {
			label: 'Quality Check',
			icon: 'queue_music',
			description: `Page de visualisation de QC`,
			disabled: true
		}
	},
	{
		path: 'audio_mapper/:id',
		name: 'AudioMapper',
		component: () => import('@/pages/maestro/forms/audio_mapper.vue'),
		meta: {
			label: 'Audiomapper',
			icon: 'queue_music',
			description: `Formulaire de mapping audio`,
			disabled: true
		}
	},
	{
		path: 'soc_babel_card/:id',
		name: 'soc_babel_card',
		component: () => import('@/pages/maestro/forms/soc_babel_card.vue'),
		meta: {
			label: 'Soc Babel Card',
			icon: 'queue_music',
			description: `Formulaire de cartes babel`,
			disabled: true
		}
	},
	{
		path: 'tmdb_select/:id',
		name: 'tmdb_select',
		component: () => import('@/pages/maestro/forms/tmdb_id_select_form.vue'),
		meta: {
			label: 'TMDB select',
			icon: 'fact_check',
			description: ``,
			disabled: true
		}
	},
	{
		path: 'conductor/:id',
		name: 'conductor',
		component: () => import('@/pages/maestro/forms/conductor_form.vue'),
		meta: {
			label: 'Conductor',
			icon: 'local_shipping',
			description: ``,
			disabled: true
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/routes_maestro.js